var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-doc",attrs:{"src":_vm.url,"width":_vm.width,"alt":_vm.title},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }